import mainState from '../state/main';
// import {} from '../actions/main';

export default (state = mainState, action) => {
  switch (action.type) {
    default: return state;
  }
};
